
<div class="match-row match-headers" [ngClass]="{'match-row-playoffs': stage === 'PLAYOFFS' && !consolation}">
  <div>{{ 'field.table' | translate }}</div>
  <div><span class="pi pi-crown team-icon team-icon-white"></span></div>
  @if(stage === 'ROUNDS' || consolation) {
    <div>{{ 'field.draw' | translate }}</div>
  } @else {
    <div></div>
  }
  <div><span class="pi pi-crown team-icon team-icon-black"></span></div>
  <div></div>
</div>
@for(match of matches; track $index) {
  <div class="match-row match-buttons">
    <!-- table -->
    <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
    <!-- white team -->
    <div (click)="authService.hasRole(['admin', 'staff', 'referee']) && tournament?.stage === stage && match.editable && 
      setMatchWinner(match, match.whiteTeamId!, match.blackTeamId!)" 
      [ngClass]="{
        'selected': isWinner(match.whiteTeamId!, match), 
        'disabled': !authService.hasRole(['admin', 'staff', 'referee']) || !match.editable || tournament?.stage !== stage
      }"
    >
      {{ match.whiteTeam?.name }}
    </div>
    <!-- draw -->
    @if(stage === 'ROUNDS' || consolation) {
      <div (click)="authService.hasRole(['admin', 'staff', 'referee']) && match.editable && setMatchWinner(match, null, null)" 
        [ngClass]="{
          'selected': isDraw(match), 
          'disabled': !authService.hasRole(['admin', 'staff', 'referee']) || !match.editable || tournament?.stage !== stage
        }"
      >
        <span class="pi pi-times"></span>
      </div>
    }
    <!-- change pieces -->
    @if(stage === 'PLAYOFFS' && !consolation) {
      <div (click)="authService.hasRole(['admin', 'staff', 'referee']) && match.editable && changePieces(match)" 
        [pTooltip]="authService.hasRole(['admin', 'staff', 'referee']) && match.editable ? ('button.change-pieces' | translate) : ''"
        tooltipPosition="top" class="change-pieces" [ngClass]="{
          'disabled': !authService.hasRole(['admin', 'staff', 'referee']) || !match.editable
        }"
      >
        <span class="pi pi-arrow-right-arrow-left"></span>
      </div>
    }
    <!-- black team -->
    <div (click)="authService.hasRole(['admin', 'staff', 'referee']) && tournament?.stage === stage && match.editable && 
      setMatchWinner(match, match.blackTeamId!, match.whiteTeamId!)" 
      [ngClass]="{
        'selected': isWinner(match.blackTeamId!, match),
        'disabled': !authService.hasRole(['admin', 'staff', 'referee']) || !match.editable || tournament?.stage !== stage
      }"
    >
      {{ match.blackTeam?.name }}
    </div>
    <!-- check -->
    <div 
      class="check"
      [ngClass]="{
        'checked': !match.editable,
        'disabled': isDisabled(match)
      }"
      [pTooltip]="isDisabled(match) ? '' : ((match.editable ? 'button.confirm-result' : 'button.edit-result') | translate)" 
      tooltipEvent="hover" tooltipPosition="top"
      (click)="!isDisabled(match) ? (match.editable ? save(match) : edit(match)) : null"
    >
      <span class="pi" [ngClass]="match.editable ? 'pi-check' : 'pi-pencil'"></span>
    </div>
  </div>
}
